
export default {
  maps: {
    pageTitle: 'openrouteservice: Shaded Edition',
    Places: 'Orte',
    isochrones: 'Isochronen',
    placeNameRequired: 'Ortsangabe benötigt',
    altitude: 'Höhenänderung',
    settings: 'Einstellungen',
    toggleAccessibleMode: 'Barrierefreien Modus aktivieren/deaktivieren',
    aboutTitle: 'Über ORS',
    updateSearch: 'In diesem Bereich suchen',
    updateSearchAfterZoomOrCenterChange: 'Orts-Suche nach Kartenbewegung aktualisieren',
    pageNotFound: 'Seite nicht gefunden. Überprüfen Sie, ob die URL unvollständig oder falsch ist'
  }
}
